import { IkasCampaignType } from "../../../models/product/campaign/data";
import { IkasOrderAdjustmentAppliedOrderLine } from "./applied-order-line";

export type IkasOrderAdjustment = {
  amount: number;
  appliedOrderLines: IkasOrderAdjustmentAppliedOrderLine[] | null;
  campaignId: string | null;
  couponId: string | null;
  name: string;
  order: number;
  amountType: IkasAmountType;
  type: IkasAdjustmentType;
  campaignType: IkasCampaignType | null;
};

export enum IkasAmountType {
  AMOUNT = "AMOUNT",
  RATIO = "RATIO",
}

export enum IkasAdjustmentType {
  DECREMENT = "DECREMENT",
  INCREMENT = "INCREMENT",
}
